import React, { useState } from "react";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddEditSession from "./AddEdit";
import ArchiveModal from "../../../../common/Common/ArchiveModal";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import SweetAlertService from "../../../../common/SweetAlert/SweetAlert";
import { archiveSessionMaster } from "../../../../redux/SessionMaster/sessionMasterSlice";
import { selectArchiveSessionMasterLoading } from "../../../../redux/SessionMaster/sessionMasterSelector";
import { formatToolName } from "../../../../common/Formatters.js/formatters";
import CommonIconButton from "../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const SessionList = ({ sampleData, onRefresh, currentPage = 1, pageSize = 10, loading }) => {
  // const [mainCheck, setMainCheck] = useState(false); // Unused currently
  // const [checkedItems, setCheckedItems] = useState([]); // Unused currently
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [sessionToArchive, setSessionToArchive] = useState(null);
  const archiveLoading = useSelector(selectArchiveSessionMasterLoading);

  const handleDialogClose = () => {
    setDialogOpen(false);
    setIsViewMode(false);
    setSelectedSession(null);
    if (onRefresh) {
      onRefresh();
    }
  };

  const handleArchiveClick = (session) => {
    setSessionToArchive(session);
    setIsOpen(true);
  };

  const handleArchiveConfirm = async () => {
    if (!sessionToArchive) return;

    // Determine if we're archiving or unarchiving
    const isArchiving = !sessionToArchive.is_archive;

    try {
      await dispatch(archiveSessionMaster({
        id: sessionToArchive.session_id,
        is_archive: isArchiving
      })).unwrap();

      setIsOpen(false);
      setSessionToArchive(null);

      SweetAlertService.showSuccess({
        title: 'Success!',
        message: `Session has been ${isArchiving ? 'archived' : 'unarchived'} successfully.`,
        onConfirm: () => {
          if (onRefresh) {
            onRefresh();
          }
        }
      });
    } catch (error) {
      setIsOpen(false);
      SweetAlertService.showError({
        title: 'Error!',
        message: error || `Failed to ${isArchiving ? 'archive' : 'unarchive'} session. Please try again.`,
      });
    }
  };

  const handleArchiveModalClose = () => {
    setIsOpen(false);
    setSessionToArchive(null);
  };

  return (
    <>
      <div className="border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr className="text-start">
              <Th className="text-start">S No.</Th>
              <Th className="text-start">Session Name</Th>
              <Th className="text-start">Tool</Th>
              {/* <Th className="text-start">Session Type</Th> */}
              <Th className="text-start">Status</Th>
              <Th className="text-start">Action</Th>
            </Tr>
          </THead>

          <TBody>
            {loading ? (
              <Tr>
                <Td colSpan={7} className="py-10 text-center">
                  <ThreeDotBouncingLoader />
                </Td>
              </Tr>
            ) : sampleData && sampleData.length > 0 ? (
              sampleData.map((item, index) => (
                <Tr key={item.session_id} className="text-start">

                  {/* Index */}
                  <Td className="text-start">
                    {String((currentPage - 1) * pageSize + (index + 1)).padStart(2, "0")}
                  </Td>

                  {/* Session Name */}
                  <Td className="text-start">{item.session_name || "N/A"}</Td>

                  {/* Tool Name */}
                  <Td className="text-start">
                    {formatToolName ? formatToolName(item.tool_name) : item.tool_name}
                  </Td>

               

                  {/* Access For */}
                  {/* <Td>
                    {item.access_for && item.access_for.length > 0 ? (
                      item.access_for.some(r => r.access_group_name === "All")
                        ? "Management, Employee"
                        : item.access_for
                          .filter(r => r.access_group_name !== "All")
                          .map(r => r.access_group_name)
                          .join(", ") || "N/A"
                    ) : (
                      "N/A"
                    )}
                  </Td> */}

                  {/* Status */}
                  <Td className="text-start">
                    <span
                      className={`inline-block px-3 py-1 text-sm font-medium rounded-full capitalize ${item.is_archive
                        ? "bg-slate-100 text-slate-700"
                        : "bg-green-100 text-green-800"
                        }`}
                    >
                      {item.is_archive ? "Archived" : "Active"}
                    </span>
                  </Td>

                  {/* Action Buttons */}
                  <Td className="text-start">
                    <div className="flex gap-1">
                      {/* View Button */}
                      <CommonIconButton
                        type="view"
                        onClick={() => {
                          setSelectedSession(item);
                          setDialogOpen(true);
                          setIsViewMode(true);
                        }}
                      >

                      </CommonIconButton>

                      {/* Edit Button */}
                      {!item.is_archive && 
                      <CommonIconButton
                        type="edit"
                        onClick={() => {
                          setSelectedSession(item);
                          setDialogOpen(true);
                          setIsViewMode(false);
                        }}
                      >
            
                      </CommonIconButton>}

                      {/* Archive/Unarchive Button */}
                      
                        {item.is_archive ? (
                        <CommonIconButton
                            type="unarchive"
                        onClick={() => handleArchiveClick(item)}
                      />
                        ) : (
                          <CommonIconButton
                            type="archive"
                        onClick={() => handleArchiveClick(item)}
                      />
                        )}
                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={7} className="text-center text-gray-500 py-6 text-sm">
                  No matching records found
                </Td>
              </Tr>
            )}
          </TBody>
        </Table>
      </div>

      <AddEditSession
        dialogOpen={dialogOpen}
        onDialogClose={handleDialogClose}
        sessionData={selectedSession}
        isViewMode={isViewMode}
      />

      <ArchiveModal
        dialogOpen={isOpen}
        onDialogClose={handleArchiveModalClose}
        onConfirm={handleArchiveConfirm}
        loading={archiveLoading}
        title={sessionToArchive?.is_archive
          ? `Are you sure you want to unarchive "${sessionToArchive?.session_name}" Session?`
          : `Are you sure you want to archive "${sessionToArchive?.session_name}" Session?`}
      />
    </>
  );
};

export default SessionList;